import React from 'react';
import { getRangeScale, getStatus, statusStyles } from '../utils/biomarkers';
import type { Biomarker } from '../types/platform';
export function BiomarkerRow({
  biomarker
}: {
  biomarker: Biomarker;
}) {
  const status = getStatus(biomarker);
  const style = statusStyles[status];
  const scale = getRangeScale(biomarker);
  return <li className="grid grid-cols-[1fr_auto] items-center gap-x-4 gap-y-2 px-5 py-3.5 md:grid-cols-[minmax(0,1.4fr)_120px_minmax(0,1fr)_90px]" data-id="element-48" data-mp="1cxrf8odrr29x">
      <div className="min-w-0" data-id="element-49" data-mp="25l408u4a7214">
        <p className="truncate font-medium" data-id="element-50" data-mp="25lx0rdcncvat">{biomarker.name}</p>
        <p className="font-mono text-[11px] text-muted-foreground" data-id="element-51" data-mp="20tvqty2ybgny">
          Ref {biomarker.min}–{biomarker.max} {biomarker.unit}
        </p>
      </div>
      <p className="text-right md:text-left" data-id="element-52" data-mp="1vuj3zdc2y9ld">
        <span className={`font-medium ${status === 'optimal' ? '' : style.text}`} data-id="element-53" data-mp="2ta6gpyn6iou1">{biomarker.value}</span>
        <span className="ml-1 text-xs text-muted-foreground" data-id="element-54" data-mp="2oj6jesa5e4r0">{biomarker.unit}</span>
      </p>
      <div className="relative col-span-2 h-1.5 rounded-full bg-white/10 md:col-span-1" aria-hidden="true" data-id="element-55" data-mp="3m5qnns3x8pfb">
        <div className="absolute h-full rounded-full bg-[#8fd3b0]/25" style={{
        left: `${scale.start}%`,
        width: `${scale.end - scale.start}%`
      }} data-id="element-56" data-mp="3r53680nrfac3" />
        <div className={`absolute top-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full ring-2 ring-[#0f1017] ${style.dot}`} style={{
        left: `${scale.value}%`
      }} data-id="element-57" data-mp="3dbc5nhs0b0si" />
      </div>
      <span className={`hidden items-center justify-end gap-1.5 text-xs md:flex ${style.text}`} data-id="element-58" data-mp="38dskdxww5nr2">
        <span className={`size-1.5 rounded-full ${style.dot}`} aria-hidden="true" data-id="element-59" data-mp="2uekgwstp3th2" />
        {style.label}
      </span>
    </li>;
}